import{useState as n,useEffect as r}from"react";var t=function(t){var o=n(),e=o[0],u=o[1];return r((function(){return e||u(new google.maps.Marker),function(){e&&e.setMap(null)}}),[e]),r((function(){e&&e.setOptions(t)}),[e,t]),null};export{t as MapMarker};
//# sourceMappingURL=MapMarker.js.map
